import { Injectable } from '@angular/core';
import { SnakeToCamel } from '@core/type/case-transform';

@Injectable({
  providedIn: 'root',
})
export class JsonTransformService {
  // SNAKE TO CAMEL CASE METHODS
  snakeToCamelCase(data: unknown): unknown {
    if (Array.isArray(data)) {
      return data.map(this.snakeToCamelCase);
    } else if (typeof data == 'object' && data != null) {
      return this.convertObjectSnakeToCamelCase(data);
    } else {
      return data;
    }
  }

  private convertObjectSnakeToCamelCase(obj: object): object {
    const newObject: object = {};
    const entries = Object.entries(obj);

    entries.forEach(([key, value]) => {
      if (Array.isArray(value)) {
        newObject[this.toCamelCase(key)] = value.map(d => this.snakeToCamelCase(d));
      } else if (typeof value == 'object' && value != null) {
        newObject[this.toCamelCase(key)] = this.snakeToCamelCase(value);
      } else {
        newObject[this.toCamelCase(key)] = value;
      }
    });
    return newObject;
  }

  private capitalize<S extends string>(string: S): Capitalize<S> {
    return (string[0].toUpperCase() + string.slice(1)) as never;
  }

  private toCamelCase<S extends string>(string: S): SnakeToCamel<S> {
    const [start, ...rest] = string.split('_');
    return (start + rest.map(this.capitalize).join('')) as never;
  }

  // CAMEL TO SNAKE CASE METHODS
  camelToSnakeCase(data: unknown): unknown {
    if (Array.isArray(data)) {
      return data.map(this.camelToSnakeCase);
    } else if (typeof data == 'object' && data != null) {
      return this.convertObjectCamelToSnakeCase(data);
    } else {
      return data;
    }
  }

  private convertObjectCamelToSnakeCase(obj: object): object {
    const newObject: object = {};
    const entries = Object.entries(obj);

    entries.forEach(([key, value]) => {
      if (Array.isArray(value)) {
        newObject[this.toSnakeCase(key)] = value.map(d => this.camelToSnakeCase(d));
      } else if (typeof value == 'object' && value != null) {
        newObject[this.toSnakeCase(key)] = this.camelToSnakeCase(value);
      } else {
        newObject[this.toSnakeCase(key)] = value;
      }
    });
    return newObject;
  }

  private toSnakeCase<S extends string>(string: S): SnakeToCamel<S> {
    const [start, ...rest] = string.replaceAll(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
    return (start + rest.join('')) as never;
  }
}
